export const BASE_PATH = "/registration";

export const REGISTRATION_STEP_PATHS = {
  name: "name",
  phone: "phone",
  accountType: "account-type",
  entityInfo: "entity-info",
} as const;

export type RegistrationSteps =
  (typeof REGISTRATION_STEP_PATHS)[keyof typeof REGISTRATION_STEP_PATHS];

// Forward every query param (redirectUrl, referrer, ...) so they survive the switch to login
export const BUILD_LOGIN_URL = (searchParams: URLSearchParams): string =>
  `/login?${searchParams.toString()}`;
